import React, { useEffect, useState } from 'react';
import ChangePassword from './ChangePassword';
import { Dropdown, Separator, TextBox } from '../../common/form';
import './settingsForm.css';
import { ThemeSetup } from '../../themes/ThemeSetup';
import SaveSettings from '../../queries/settings/SaveSettings';
import ToolTip from '../../common/AssetPropertyView';
import t from './../../i18n/I18n';
import AuthenticationController from '../../controllers/AuthenticationController';

const debug = require('../../debug/debug')('wc:setting:SettingForm');

const CHANGE_PASSWORD = 'CHANGE_PASSWORD';

const SettingsForm = ({ formData }) => {
  if (!formData[0].length) return null;
  return (
    <div name="SettingForm">
      {formData.map((form, index) => {
        return (
          <div key={index}>
            {form.map((value) => (
              <Form key={value.key} form={value} />
            ))}
            {form.length && <Separator />}
          </div>
        );
      })}
    </div>
  );
};

const CustomTooltip = (props: { description: string, defaultValue: string }) => {
  let showToolTip = props.description || props.defaultValue;
  if (showToolTip) {
    let message: string = null;
    if (props.description) {
      message = props.description;
      if (props.defaultValue) {
        if (!message.endsWith('.')) message = message + '.';
      }
    } else {
      //Note: No need to display default value. People won't understand the default values as true or false.
      //If want to display default values they need to formatted.
      // const defaultPropertyText: string = t('PROPERTY_DEFAULT_VALUE_TOOLTIP_TEXT', { VALUE: props.defaultValue })
      // message = defaultPropertyText;
    }

    const toolTip = (
      <React.Fragment>
        {/* {props.defaultValue && <div style={{ marginBottom: '10px',fontSize: '12px' }}>{`Default: ${props.defaultValue}`}</div>} */}
        {message && (
          <div style={{ fontSize: '14px' }}>
            <span style={{ whiteSpace: 'pre-wrap' }}>{message}</span>
          </div>
        )}
      </React.Fragment>
    );

    return (
      <ToolTip customToolTip={toolTip} maxWidth={500} wordBreak="normal">
        {props.children}
      </ToolTip>
    );
  }
  return props.children;
};

const Form = ({ form }) => {
  const [ModalName, setModalName] = useState(null);
  const [value, setValue] = useState(form.value);
  const width = ['input', 'integer', 'string', 'dropDown'].includes(form.type) ? 350 : 500;

  useEffect(() => setValue(form.value), [form]);

  const getModalName = (type) => {
    switch (type) {
      case 'password':
        return CHANGE_PASSWORD;
    }
  };

  const onChangeHandler = (updatedValue) => {
    setValue(updatedValue);
    if ('dropDown' == form.type) {
      updatedValue = form.options[updatedValue].label;
    }
    // if (form.value !== updatedValue) {
      SaveSettings.saveAsync(form.key, updatedValue)
        .then(() => {
          if (form.key === 'VIEWPROPS') {
            AuthenticationController.updateSessionSettings();
          }
          window.render();
        })
        .catch(() => {
          debug(`[SaveSetting:] issue in save setting for key ${form.key} and value ${updatedValue}`);
          window.render();
        });
    // }
  };

  return (
    <div className="form">
      <div className="value_label label">{form.label}</div>
      <div className="value-description">
        <CustomTooltip description={form.description} defaultValue={form.defaultValue}>
          {'Modal' == form.type && (
            <span className="modal_link" onClick={(e) => setModalName(getModalName(form.key))}>
              {form.value}
            </span>
          )}
          {['input', 'integer', 'string'].includes(form.type) && (
            <TextBox
              type={'integer' == form.type ? 'number' : 'text'}
              className="flex-main"
              value={value}
              onBlur={() => onChangeHandler(value)}
              onChange={(e) => {
                setValue(e.target.value);
              }}
              clearable={value ? true : false}
            />
          )}
          {'bool' == form.type && (
            <img
              name="checkBox"
              onClick={() => onChangeHandler(value == 'true' ? 'false' : 'true')}
              src={
                value == 'true'
                  ? ThemeSetup.getImageURL('Icon_Checkmark.svg')
                  : ThemeSetup.getImageURL('Icon_Rectangle_Shape.svg')
              }
            />
          )}
          {'dropDown' == form.type && (
            <Dropdown
              value={value}
              options={form.options}
              onChange={(value) => onChangeHandler(value)}
              className="sideBySideInput boxedDropDown inputText"
              style={{ padding: '0 10px', width: '300px' }}
              // placeholder={'placeHolderText'}
            />
          )}
        </CustomTooltip>
      </div>
      {CHANGE_PASSWORD == ModalName && <ChangePassword onClose={() => setModalName(null)} />}
    </div>
  );
};

export default SettingsForm;
